import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-6 shadow" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_8 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link text-active-primary me-6 active",
    href: "#tabs_edit_general",
    "data-bs-toggle": "tab"
  }, "Thông tin chung")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link text-active-primary me-6",
    href: "#tabs_edit_content",
    "data-bs-toggle": "tab"
  }, "Nội dung")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nav-link text-active-primary me-6",
    href: "#tabs_edit_seo",
    "data-bs-toggle": "tab"
  }, "SEO")
], -1)
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link text-active-primary me-6",
  href: "#tabs_career",
  "data-bs-toggle": "tab"
}, "Thông tin tuyển dụng", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_16 = { class: "card-body pt-10" }
const _hoisted_17 = { class: "tab-content" }
const _hoisted_18 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_19 = { class: "my-5 px-8" }
const _hoisted_20 = { class: "row g-9 mb-8" }
const _hoisted_21 = { class: "col-md-8 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tiêu đề bài viết", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Đường dẫn bài viết", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Danh mục tin", -1)
const _hoisted_25 = { class: "col-md-4 fv-row" }
const _hoisted_26 = { class: "d-flex justify-content-between" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Ảnh đại diện ", -1)
const _hoisted_28 = { class: "svg-icon svg-icon-2" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_30 = ["src"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)
const _hoisted_32 = {
  class: "tab-pane fade",
  id: "tabs_edit_content",
  item: "tabpanel"
}
const _hoisted_33 = { class: "my-5 px-8" }
const _hoisted_34 = { class: "row g-9 mb-8" }
const _hoisted_35 = { class: "col-md-12 fv-row mt-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Mô tả"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "e"
  })
], -1)
const _hoisted_37 = { class: "col-md-12 fv-row mt-1" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Nội dung bài viết")
], -1)
const _hoisted_39 = {
  class: "tab-pane fade",
  id: "tabs_edit_seo",
  item: "tabpanel"
}
const _hoisted_40 = { class: "d-flex flex-column px-9" }
const _hoisted_41 = { class: "row g-9 mb-8" }
const _hoisted_42 = { class: "col-md-12 fv-row" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Robots", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Tiêu đề seo", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Nội dung seo", -1)
const _hoisted_46 = {
  class: "tab-pane fade",
  id: "tabs_career",
  item: "tabpanel"
}
const _hoisted_47 = { class: "d-flex flex-column px-9" }
const _hoisted_48 = { class: "row g-9 mb-8" }
const _hoisted_49 = { class: "col-md-6 fv-row mb-2 mt-10" }
const _hoisted_50 = { class: "fs-6 fw-bold" }
const _hoisted_51 = { class: "col-md-6 fv-row mb-2 mt-10" }
const _hoisted_52 = { class: "fs-6 fw-bold" }
const _hoisted_53 = { class: "col-md-6 fv-row my-2" }
const _hoisted_54 = { class: "fs-6 fw-bold" }
const _hoisted_55 = { class: "col-md-6 fv-row my-2" }
const _hoisted_56 = { class: "fs-6 fw-bold" }
const _hoisted_57 = { class: "col-md-6 fv-row my-2" }
const _hoisted_58 = { class: "fs-6 fw-bold" }
const _hoisted_59 = { class: "col-md-6 fv-row my-2" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Hạn nộp hồ sơ", -1)
const _hoisted_61 = { class: "col-md-6 fv-row my-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Kinh nghiệm", -1)
const _hoisted_63 = { class: "col-md-6 fv-row my-2" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Mức lương", -1)
const _hoisted_65 = { class: "col-md-6 fv-row my-2" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Cấp bậc", -1)
const _hoisted_67 = { class: "col-md-6 fv-row my-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Hình thức làm việc", -1)
const _hoisted_69 = { class: "col-md-6 fv-row my-2" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Số lượng tuyển", -1)
const _hoisted_71 = { class: "col-md-6 fv-row my-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Yêu cầu giới tính", -1)
const _hoisted_73 = { class: "col-md-6 fv-row my-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Yêu cầu độ tuổi", -1)
const _hoisted_75 = { class: "col-md-6 fv-row my-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Yêu cầu bằng cấp", -1)
const _hoisted_77 = { class: "col-md-6 fv-row my-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Thời gian thử việc", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "edit_news_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_affix, { offset: 120 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.objectData.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "btn-primary btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _withDirectives(_createElementVNode("li", _hoisted_12, _hoisted_14, 512), [
                    [_vShow, _ctx.showPositionCareer]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectData.name))),
                          modelValue: _ctx.objectData.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.name) = $event)),
                          placeholder: "Tiêu đề bài viết",
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_23,
                    _createVNode(_component_el_form_item, { prop: "slug" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.slug,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.slug) = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectData.slug))),
                          placeholder: "Nhập vào họ và tên",
                          name: "slug"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_24,
                    _createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.categories,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectData.categories) = $event)),
                          multiple: "",
                          "default-first-option": "",
                          placeholder: "Danh mục tin"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataNewsCategory, (item, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                _createVNode(_component_el_option, {
                                  label: item.name,
                                  value: item._id
                                }, null, 8, ["label", "value"]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child_, index_) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: index_ }, [
                                    (child_._id)
                                      ? (_openBlock(), _createBlock(_component_el_option, {
                                          key: 0,
                                          label: '--' + child_.name,
                                          value: child_._id
                                        }, null, 8, ["label", "value"]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 128))
                              ], 64))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "Trạng thái hiển thị" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.objectData.status,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objectData.status) = $event)),
                          "active-color": "#13ce66",
                          "inactive-color": "#ff4949",
                          "active-value": "active",
                          "inactive-value": "inactive"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showSingleMedia('thumbnail'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_28, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_29
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _ctx.renderImageUrl(_ctx.objectData.thumbnail, 'thumbnail'),
                          alt: ""
                        }, null, 8, _hoisted_30)
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_31
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode(_component_el_form_item, { prop: "short_content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: _ctx.objectData.short_content,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objectData.short_content) = $event)),
                          placeholder: "Mô tả",
                          rows: "4",
                          name: "short_content"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode(_component_editor, {
                      "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                      modelValue: _ctx.objectData.content,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objectData.content) = $event)),
                      init: _ctx.editorConfig
                    }, null, 8, ["modelValue", "init"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_el_form_item, { prop: "robot" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.seo.robot,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objectData.seo.robot) = $event)),
                          placeholder: "",
                          name: "robot"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "index, follow",
                              value: "index, follow"
                            }),
                            _createVNode(_component_el_option, {
                              label: "index, nofollow",
                              value: "index, nofollow"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_44,
                    _createVNode(_component_el_form_item, { prop: "seo.title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.title,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objectData.seo.title) = $event)),
                          placeholder: "",
                          name: "seo_title"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_45,
                    _createVNode(_component_el_form_item, { prop: "seo.description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.description,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objectData.seo.description) = $event)),
                          placeholder: "",
                          name: "seo_des",
                          rows: "4",
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _withDirectives(_createElementVNode("label", _hoisted_50, "Vị trí tuyển dụng", 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ]),
                    _withDirectives(_createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.position_career,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.objectData.position_career) = $event)),
                          "default-first-option": "",
                          placeholder: "Chọ vị trí "
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataPositionCareer, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.value,
                                value: item.key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("label", _hoisted_52, "Địa điểm làm việc", 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ]),
                    _withDirectives(_createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.location_career,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.objectData.location_career) = $event)),
                          "default-first-option": "",
                          placeholder: "Chọn địa điểm "
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataLocationCareer, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: index,
                                label: item.value,
                                value: item.key
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("label", _hoisted_54, "Địa chỉ làm việc", 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ]),
                    _withDirectives(_createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.address_work,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.objectData.address_work) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _withDirectives(_createElementVNode("label", _hoisted_56, "Email liên hệ", 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ]),
                    _withDirectives(_createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.email_contact,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.objectData.email_contact) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _withDirectives(_createElementVNode("label", _hoisted_58, "Điện thoại liên hệ", 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ]),
                    _withDirectives(_createVNode(_component_el_form_item, { prop: "categories" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.phone_contact,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.objectData.phone_contact) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.showPositionCareer]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _hoisted_60,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.objectData.data_info.expiry_date,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.objectData.data_info.expiry_date) = $event)),
                          type: "date",
                          placeholder: "Hạn nộp"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.experience,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.objectData.data_info.experience) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.salary,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.objectData.data_info.salary) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.level,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.objectData.data_info.level) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.working_time,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.objectData.data_info.working_time) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: _ctx.objectData.data_info.number,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.objectData.data_info.number) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.sex,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.objectData.data_info.sex) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.age,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.objectData.data_info.age) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _hoisted_76,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.qualification,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.objectData.data_info.qualification) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createVNode(_component_el_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.data_info.probationary_period,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.objectData.data_info.probationary_period) = $event)),
                          placeholder: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ], 512), [
              [_vShow, _ctx.showPositionCareer]
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}